import { render } from "./CalendarEventOffersListItem.vue?vue&type=template&id=1848d3e7&scoped=true"
import script from "./CalendarEventOffersListItem.vue?vue&type=script&lang=ts"
export * from "./CalendarEventOffersListItem.vue?vue&type=script&lang=ts"

import "./CalendarEventOffersListItem.vue?vue&type=style&index=0&id=1848d3e7&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1848d3e7"

export default script